import { createSlice } from "@reduxjs/toolkit";
import { getTalents } from "./thunk";

export interface IState {
  talents: any;
  isTalentLoading: boolean;
  isTalentSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  talents: null,
  isTalentLoading: false,
  isTalentSuccess: false,

  error: {},
};

const TalentSlice = createSlice({
  name: "Talent",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //getTalents
    builder.addCase(getTalents.pending, (state: IState, action: any) => {
      state.isTalentLoading = true;
    });
    builder.addCase(getTalents.fulfilled, (state: IState, action: any) => {
      state.talents = action.payload.data;
      state.isTalentSuccess = true;
      state.isTalentLoading = false;
    });
    builder.addCase(getTalents.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isTalentSuccess = false;
      state.isTalentLoading = false;
    });

  },
});

export default TalentSlice.reducer;